import { createFileRoute } from "@tanstack/react-router";
import WebhooksList from "@/features/webhooks/WebhookList";

export const Route = createFileRoute("/_layout/webhooks")({
  component: WebhooksList,
});
